<template>
  <div class="section-card">
    <div class="section-row">
      <div class="section-copy">
        <p class="section-title mb-1">{{ item.title.label }}</p>
        <p class="card-desc">{{ item.title.value || "-" }}</p>
      </div>
      <div class="section-status">
        <p class="section-title">{{ item.status.label }}</p>
        <StatusInline :status="item.status.value" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import StatusInline from "@/shared/components/ui/StatusInline.vue";

defineProps<{
  item: {
    title: {
      label: string;
      value: string;
    };
    status: {
      label: string;
      value: string;
    };
  };
}>();

</script>

<style scoped>

.section-card {
  background: #fff;
  border-radius: 18px !important;
  padding: 16px;
  display: flex;
  flex-direction: column;
  border: none !important;
  gap: 14px;
}

.section-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.section-copy{
  text-align: left;
  font-weight: 600;
}
.section-status {
  min-width: 0;
  text-align: right;
}

.section-title {
  margin: 0;
  font-size: 13px;
  letter-spacing: 0.1em;
  text-transform: capitalize;
  color: var(--color-title);
  font-weight: 500;
}

.card-desc {
  line-height: 1.5;
  font-size: 14px;
}
</style>
